// i18nZodErrorMap.ts
import { z } from "zod";
import i18next from "i18next";

export const zodI18nErrorMap: z.ZodErrorMap = (issue) => {
	const path = issue.path[0];
	const field = i18next.t(`fields.${path}` as any);

	// const params = "params" in issue ? issue.params : {};

	const message = i18next.t(`validation.${issue.code}`, {
		field,
		...issue,
	});

	return { message };
};

z.setErrorMap(zodI18nErrorMap); // register globally
